export interface UserMinimal {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}

export type MeetingType =
  | 'OAC'
  | 'SUBCONTRACTOR'
  | 'SAFETY'
  | 'PRECON'
  | 'PROGRESS'
  | 'DESIGN'
  | 'OTHER';

export type MeetingStatus =
  | 'SCHEDULED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'CANCELLED';

export interface MeetingSummary {
  id: string;
  project: number;
  title: string;
  meeting_type: MeetingType;
  meeting_type_display: string;
  status: MeetingStatus;
  status_display: string;
  scheduled_at: string;
  duration_minutes: number;
  location: string;
  organizer: UserMinimal | null;
  attendee_count: number;
  created_at: string;
  updated_at: string;
}

export interface Meeting extends MeetingSummary {
  meeting_link: string;
  agenda: string;
  summary: string;
  decisions: string;
  action_items: string;
  attendees_internal: UserMinimal[];
  attendees_external: string;
  created_by: UserMinimal | null;
}

export interface MeetingDraft {
  project: number;
  title: string;
  meeting_type: MeetingType;
  status: MeetingStatus;
  scheduled_at: string;
  duration_minutes: number;
  location: string;
  meeting_link: string;
  agenda: string;
  summary: string;
  decisions: string;
  action_items: string;
  attendees_external: string;
  organizer_id?: number | null;
  attendees_internal_ids: number[];
}

export type MeetingPatch = Partial<Omit<MeetingDraft, 'project'>>;

export interface MeetingFilters {
  status?: MeetingStatus;
  meeting_type?: MeetingType;
  search?: string;
  page?: number;
  page_size?: number;
}

export interface PaginatedMeetings {
  count: number;
  next: string | null;
  previous: string | null;
  results: MeetingSummary[];
}

export const MEETING_TYPE_LABELS: Record<MeetingType, string> = {
  OAC: 'Owner / Architect / Contractor',
  SUBCONTRACTOR: 'Subcontractor Coordination',
  SAFETY: 'Safety',
  PRECON: 'Pre-construction',
  PROGRESS: 'Progress',
  DESIGN: 'Design Review',
  OTHER: 'Other',
};

export const MEETING_STATUS_LABELS: Record<MeetingStatus, string> = {
  SCHEDULED: 'Scheduled',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};
